import { createSelector } from 'reselect'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

export const isNextHotelIndexEnabled = createSelector(
  (state: App.State) => state.optimizely.optimizelyFeatureFlags,
  (featureFlags): boolean => {
    return !!featureFlags[OptimizelyFeatureFlags.searchNewHotelIndex]
  },
)
